import React from 'react'
import { useFormikContext } from 'formik'
import { makeStyles } from '@mui/styles'
import { FormControlLabel, Grid, Radio, Typography } from '@mui/material'

import ProfileFormWrapper from 'components/wrappers/ProfileFormWrapper'

import { VideosSlider } from './helpers'
import useAttributes from 'utils/hooks/useAttributes'

import { ProfileFormValues } from '../config'
import CheckList from 'components/CheckList'

const useStyles = makeStyles((theme) => {
  return {
    sliderContainer: {
      marginInline: '-50px',
      [theme.breakpoints.down('sm')]: {
        marginInline: '-4px',
      },
    },
  }
})

const ProfileFormReviewExperience = () => {
  const classes = useStyles()
  const { values, errors, setValues } = useFormikContext<ProfileFormValues>()

  const { attributes, isLoading } = useAttributes(['level_of_interest'])

  const { level_of_interest } = attributes

  return (
    <ProfileFormWrapper
      title="Video review experience"
      stepDescription="Please let us know your comfort and experience level with creating short form video reviews. You can explore a few example videos below to become familiar with the Hue review format!"
    >
      <Grid className={classes.sliderContainer} mb={5.5}>
        <VideosSlider />
      </Grid>
      <Grid mb={2.5}>
        <CheckList
          title="What is your level of experience in creating short form video reviews?"
          error={errors.validationErrors?.level_of_interest}
          isLoading={isLoading}
        >
          <Grid container flexDirection="column" gap={0.5}>
            {level_of_interest?.options?.map((item) => {
              const { code, text } = item
              return (
                <Grid key={code}>
                  <FormControlLabel
                    control={
                      <Radio
                        color="mint"
                        size="small"
                        disableRipple
                        checked={
                          code ===
                          values.getValueByAttribute(
                            'level_of_interest',
                            'CONTENT',
                            values.attributes
                          )?.value
                        }
                        onChange={() => {
                          setValues(
                            values.setAttributeValue({
                              attribute: 'level_of_interest',
                              category: 'CONTENT',
                              value: item,
                            })
                          )
                        }}
                      />
                    }
                    label={<Typography fontSize="14px">{text}</Typography>}
                  />
                </Grid>
              )
            })}
          </Grid>
        </CheckList>
      </Grid>
    </ProfileFormWrapper>
  )
}

export default ProfileFormReviewExperience
